import config from 'devextreme/core/config';
import { locale, loadMessages } from 'devextreme/localization';
import frDevExtreme from 'devextreme/localization/messages/fr.json';
import itDevExtreme from 'devextreme/localization/messages/it.json';
import esDevExtreme from 'devextreme/localization/messages/es.json';
import deDevExtreme from 'devextreme/localization/messages/de.json';
import { languages } from '~/constants';

export default defineNuxtPlugin(() => {
  const currency = localStorage.getItem('partnerCurrency') || 'EUR';
  let userLocale = localStorage.getItem('userLocale') || 'fr';

  if (!userLocale) {
    userLocale = navigator.language.slice(0, 2);
  }

  if (!languages.includes(userLocale)) {
    userLocale = languages[0];
  }

  loadMessages(frDevExtreme);
  loadMessages(itDevExtreme);
  loadMessages(esDevExtreme);
  loadMessages(deDevExtreme);
  locale(userLocale);

  config({ defaultCurrency: currency });
});
